import { render, staticRenderFns } from "./IconEmbed.vue?vue&type=template&id=1cd425c4&"
import script from "./IconEmbed.vue?vue&type=script&lang=js&"
export * from "./IconEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports